import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  languages: [],
  loading: false,
  error: null,
  purchasedLanguages: [],
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    fetchLanguagesRequest: (state) => {
      state.loading = true;
    },
    fetchLanguagesSuccess: (state, action) => {
      state.languages = action.payload;
      state.loading = false;
    },
    fetchLanguagesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchLanguagesRequest,
  fetchLanguagesSuccess,
  fetchLanguagesFailure,
} = languageSlice.actions;

export default languageSlice.reducer;
